import {
    fuzzyMatchCode,
    fuzzyMatchPhone,
    fuzzyMatchText
} from './fuzzyMatch'

/**
 * Search for a value in an array of object
 * Supply the array of object and the search term object
 * @param {Array} arraySearchList
 * @param {Object} searchTerm
 */

export const searchHandler = (arraySearchList, searchTerm) => {
    const searchTerms = Object.entries(searchTerm)

    const searchResult = arraySearchList.filter((searchObj) =>
        searchTerms.find(([key, value]) => {
            const valueNoWhiteSpace = value.replace(/\s\s+/g, ' ')

            if (key === 'phone') {
                return fuzzyMatchPhone(searchObj.phone, valueNoWhiteSpace)
            }

            if (key === 'client_code') {
                return fuzzyMatchCode(searchObj.client_code, valueNoWhiteSpace)
            }

            if (key === 'reversed_fullname' && !(key in searchObj)) {
                const combined = `${searchObj.lastname || ''} ${
                    searchObj.firstname || ''
                }`.trim()
                return fuzzyMatchText(combined, valueNoWhiteSpace)
            }

            return fuzzyMatchText(searchObj[key] || '', valueNoWhiteSpace)
        })
    )
    return searchResult
}
